<template lang="pug">
#color-selecter.input-el(
	:disabled="(state === 'view')"
	:class="{disabled: state === 'view'}"
	@mouseleave="close"
	@close="close"
)
	div.row.select(@click="openClose" @blur="close" @focusout="close" @close="close")
		span.chip(:style="`background-color:${selectedColor.code};`")
		p {{ selectedColor.name }}
		template(v-if="state !== 'view'"): include ../../resources/icons/chevron-down.pug
	.col.input-el(v-if="opened")
		template(
			v-for="colour in colors"
			:key="`c-${colour.name}`"
		)
			.row(@click="makeSelection(colour)")
				span.chip(:style="`background-color:${colour.code};`")
				p {{ colour.name }}

			//- div.row(@click="makeSelection(color)")
			//- 	span.chip(:style="`background-color:${color.code};`")
			//- 	p {{ color.name }}

</template>
<script setup lang="ts">
import { ref, watch } from 'vue';

type Color = {[key:string|symbol]:string};
type Emits = {(e: 'update:color', color: string): void};

const props = defineProps<{color: string, state: string}>();
const emit = defineEmits<Emits>();
const opened = ref<boolean>(false);

const colors = [
	{code: "#A70024", fontColor: "#FFF", name: "tomato",},
	{code: "#E67C73", fontColor: "#001", name: "flamingo",},
	{code: "#FFB878", fontColor: "#001", name: "tangerine",},
	{code: "#FBD75B", fontColor: "#001", name: "banana",},
	{code: "#33B679", fontColor: "#001", name: "sage",},
	{code: "#0B8043", fontColor: "#FFF", name: "basil",},
	{code: "#039BE5", fontColor: "#FFF", name: "peacock",},
	{code: "#3F51B5", fontColor: "#FFF", name: "blueberry",},
	{code: "#7986CB", fontColor: "#FFF", name: "lavender",},
	{code: "#616161", fontColor: "#FFF", name: "graphite",},
];

const close = () => {opened.value = false;};
const openClose  = () => {
	opened.value = props.state === "view" ? false : !opened.value;
};

const selectedColor = ref<Color>(
	colors.find(c => (c.code === props.color))
	|| {name: "peacock", code: "#039BE5", fontColor: "#FFF"}
);

watch(() => props.color, () => ([selectedColor.value] = colors.filter(c => c.code === props.color)));

function makeSelection(color: Color ) {
	openClose();
	selectedColor.value = color;
	if(color) emit('update:color', color.code);
}

</script>
<style lang="scss">

#color-selecter{
	position: relative;
	height: fit-content;
	min-height: 24px;
	cursor: pointer;

	&, .select, .col, .row{
		width: 10rem;
	}

	&:disabled, &.disabled{
		cursor: default;
		outline-color: transparent;
	}


	.select{
		padding: 0.25rem;
	}

	.row, .select{
		padding: 0.5rem;
	}

	.col, .row{
		display: grid;
		gap: 0 0.5rem;
	}

	.col{
		position: absolute;
		left: -4px;
		z-index: 1;
		height: fit-content;
	}

	.row{
		box-sizing: border-box;
		grid-template-columns: 24px 1fr;
		border: 1px solid transparent;
	}

	.row:hover{
		border-color: $color-black transparent;
	}

	.row p{
		margin-block: unset;
		text-transform: capitalize;
	}

	option .chip,
	.row .chip{
		display: block;
		width : 24px;
		height: 24px;
		content: "";
		border-radius: 50%;
	}

	.row:last-of-type:not(:first-of-type){
		padding-bottom: 0.75rem;
	}
}

#manage-calendar-modal #color-selecter svg.icon {
	width: 1.5rem;
	height: 1.5rem;
}
</style>